<template>
  <v-card>
    <template v-if="isLoading">
      <loading/>
    </template>
    <template v-else>
      <v-card v-for="(article, index) in news" :key="index" class="elevation-0">
        <v-card-title primary-title>
          <div>
            <div class="headline">{{ article.title }}</div>
            <span class="grey--text">
          <v-icon small>mdi-calendar</v-icon>
            {{ article.created_on }}
          </span>
          </div>
        </v-card-title>
        <v-card-text v-html="article.content"/>
        <v-divider/>
      </v-card>
      <div class="text-xs-center" v-if="!$vuetify.breakpoint.xs">
        <v-pagination
          v-model="page"
          :length="pagesNumber"
          :total-visible="7"
          circle
          @input="next"
        ></v-pagination>
      </div>
    </template>
  </v-card>
</template>

<script>
import DashboardApi from '../api'
import Loading from '@/components/helpers/Loading'

export default {
  name: 'DashboardNews',
  components: {
    Loading
  },
  data () {
    return {
      isLoading: false,
      news: [],
      page: 1,
      pagesNumber: 0
    }
  },
  methods: {
    next (page) {
      this.loadData(page)
    },
    async loadData (page = 1) {
      this.isLoading = true
      let news = await DashboardApi.getNews(page)
      if (news.success) {
        this.news = news.data
        this.pagesNumber = news.pagesNumber
        this.isLoading = false
      } else {
        console.log(news.error)
        this.isLoading = false
      }
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style>
</style>
